import { Component, Input, ViewEncapsulation, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-table-with-title',
  templateUrl: './table-with-title.component.html',
  styleUrls: ['./table-with-title.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TableWithTitleComponent {

  panelExpanded: boolean = true;
  @Input() title: string = '';
  @Input() width: string = '';
  @Input() height: string = '';
  @Input() isAddingOrEditing: string = 'adding';
  @Input() isFirstQuestionnaire: boolean = false;
  @Input() incommingDataArray: Array<any> = [];

  @Output() addOrEditButton = new EventEmitter();

  constructor() {}

  executeFunction() {

    this.addOrEditButton.emit();
  }

  showSelectedItemsOnly(incommingDataArray: any) {

    return incommingDataArray.filter((item: any) => item.selected === true);
  }

  applyDesign() {

    return { width: this.width, display: 'grid' };
  }

  applyTableDesign() {

    return { 'min-height': this.height, width: 'calc(this.width - 3px)' };
  }

  autoResize(event: Event) {

    const textarea = event.target as HTMLTextAreaElement;

    if (textarea) {

      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';

      if (textarea.offsetHeight > textarea.scrollHeight) {

        textarea.style.height = `${textarea.offsetHeight}px`;
      }
    }
  }
}
